import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PublicLayout } from "@/components/PublicLayout";

export default function ForgotPassword() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const run = async (fn) => {
    setBusy(true);
    try { await fn(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  const send = (e) => { e.preventDefault(); run(async () => { const { data } = await api.post("/auth/forgot-password", { email }); toast.success(data.message); setStep(2); }); };
  const verify = (e) => { e.preventDefault(); run(async () => { await api.post("/auth/verify-reset-code", { email, code: code.trim() }); setStep(3); }); };
  const reset = (e) => { e.preventDefault(); run(async () => { await api.post("/auth/reset-password", { token: code.trim(), new_password: pw }); toast.success("Password reset! Please log in."); nav("/login"); }); };

  return (
    <PublicLayout>
      <section className="max-w-md mx-auto px-5 pt-14 mm-fade-up">
        <div className="mm-card p-8">
          <h1 className="text-3xl font-bold">Reset password</h1>
          <p className="text-mm-muted text-sm mt-1">Step {step} of 3</p>
          {step === 1 && (
            <form onSubmit={send} className="space-y-3 mt-6">
              <input className="mm-input" type="email" required placeholder="Your account email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
              <button className="mm-btn w-full" disabled={busy} data-testid="forgot-send-code-button">Send reset code</button>
            </form>
          )}
          {step === 2 && (
            <form onSubmit={verify} className="space-y-3 mt-6">
              <p className="text-sm text-mm-muted">Check your inbox for the code we sent to <b>{email}</b>.</p>
              <input className="mm-input font-mono" required placeholder="Paste your reset code" value={code} onChange={(e) => setCode(e.target.value)} data-testid="forgot-code-input" />
              <button className="mm-btn w-full" disabled={busy} data-testid="forgot-verify-button">Verify code</button>
            </form>
          )}
          {step === 3 && (
            <form onSubmit={reset} className="space-y-3 mt-6">
              <input className="mm-input" type="password" required placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="forgot-new-password-input" />
              <p className="text-xs text-mm-muted">8+ characters with upper, lower and a number.</p>
              <button className="mm-btn w-full" disabled={busy} data-testid="forgot-reset-button">Set new password</button>
            </form>
          )}
          <Link to="/login" className="block text-center text-sm text-mm-primary font-semibold mt-6" data-testid="forgot-back-to-login">Back to login</Link>
        </div>
      </section>
    </PublicLayout>
  );
}
